/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'helpdesk': {
    width: 16,
    height: 16,
    viewBox: '0 0 500 500',
    data: '<g data-name="Layer 2" _fill="#fff"><path pid="0" d="M416.67 378.77a218.2 218.2 0 01-121.28 72.85c-.09-.55-.18-1.11-.26-1.66a7.34 7.34 0 00-8.36-6.35q-8.85 1.54-17.81 2.69a14 14 0 00-12.16 13.5c-.25 8.64 6.73 15.45 14.65 14.46q13.55-1.68 26.81-4.26c-.26-1.73-.54-3.48-.81-5.25A232 232 0 00442.18 367a33.35 33.35 0 00-25.51 11.77zM416.51 116.39a33.64 33.64 0 0025.67 12C400.61 66.45 330 25.64 250 25.64S99.34 66.45 57.77 128.35a33.66 33.66 0 0025.68-12 217.76 217.76 0 01333.06 0z"/><rect pid="1" x="425.27" y="171.96" width="49.24" height="128.53" rx="24.62"/><path pid="2" d="M50.11 172a24.62 24.62 0 00-24.62 24.62v79.29a24.62 24.62 0 0049.24 0v-79.33A24.62 24.62 0 0050.11 172zM344.29 152.8A131.79 131.79 0 00141.08 319l-15.52 53.89 54.8-16A131.79 131.79 0 00344.29 152.8zm-78.66 139.1h-95.18v-12.45h95.18zm64.42-27h-159.6v-12.46h159.6zm0-27h-159.6v-12.48h159.6zm0-27h-159.6v-12.5h159.6z"/></g>'
  }
})
